export default __webpack_public_path__ + "static/meshmark-formula-f6dfed1dd2c3aa00dcf6e46dee1598da.png";